module.exports = __webpack_public_path__ + "images/bill-logo.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader/dist/cjs.js?name=images/[name].[ext]!./src/images/email/bill-logo.png
// module id = ./node_modules/file-loader/dist/cjs.js?name=images/[name].[ext]!./src/images/email/bill-logo.png
// module chunks = 21